import React, { useEffect, useState } from 'react';
import { authService } from '../services/authService';

const ProtectedRoute = ({ children }) => {
  const [isChecking, setIsChecking] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      // Check if user exists (token is in HTTP-only cookie)
      const user = authService.getCurrentUser();
      console.log('ProtectedRoute - Checking auth, user exists:', !!user);
      
      if (!user) {
        console.log('No user data found - redirecting to login');
        setIsAuthenticated(false);
        setIsChecking(false);
        return;
      }

      // User data exists - allow access
      // Token is in HTTP-only cookie and sent automatically with requests
      console.log('User data found - allowing access');
      setIsAuthenticated(true);
      setIsChecking(false);
      
      // Optionally verify in background (non-blocking)
      authService.verifyToken().then(valid => {
        if (!valid) {
          console.warn('Token verification failed - but user already in portal');
          // Optionally logout if token is really invalid
          // authService.logout();
        }
      }).catch(err => {
        console.warn('Token verification error:', err);
      });
    };

    checkAuth();
  }, []);

  // Show loading screen while checking authentication
  if (isChecking) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-primary-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600 font-medium">Loading...</p>
        </div>
      </div>
    );
  }

  // If not authenticated, redirect to landing page login
  if (!isAuthenticated) {
    const landingUrl = process.env.REACT_APP_LANDING_URL || 'http://localhost:3000';
    console.log('Not authenticated - redirecting to:', `${landingUrl}/login`);
    window.location.href = `${landingUrl}/login`;
    return null;
  }

  // User is authenticated, render protected content
  return children;
};

export default ProtectedRoute;
